module.exports = __webpack_public_path__ + "assets/img/vipIcon6.fa13e134.png";